export function formatKwh(value: number): string {
	const rounded = Math.round(value * 100) / 100;
	const str = rounded.toString();
	return str.includes(".") ? str : str + ".0";
}
